export default __webpack_public_path__ + "static/media/icon-3-green-round.27af87f5.svg";